import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const SYSTEM_PAGE_KEY = 'systemPageAccess';
export const ERROR_PAGE_PATH = '/error';
export const PAGE_NOT_FOUND_PATH = '/page-not-found';
export const ERROR_RETRY_KEY = 'errorPageRetryAt';

const ERROR_RETRY_WINDOW_MS = 10_000;

let initialCheckDone = false;

function documentLoadedAt(path: string): boolean {
  const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
  if (!nav || (nav.type !== 'navigate' && nav.type !== 'reload')) {
    return false;
  }
  try {
    return new URL(nav.name).pathname === path;
  } catch {
    return false;
  }
}

export function allowSystemPageNavigation(path: string): void {
  sessionStorage.setItem(SYSTEM_PAGE_KEY, path);
}

export function clearSystemPageAccess(): void {
  sessionStorage.removeItem(SYSTEM_PAGE_KEY);
}

export const systemPageGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const allowedPath = sessionStorage.getItem(SYSTEM_PAGE_KEY);
  const currentPath = state.url.split('?')[0].split('#')[0];

  if (allowedPath === currentPath) {
    const firstCheck = !initialCheckDone;
    initialCheckDone = true;

    if (
      currentPath === ERROR_PAGE_PATH &&
      firstCheck &&
      documentLoadedAt(ERROR_PAGE_PATH) &&
      Date.now() - Number(sessionStorage.getItem(ERROR_RETRY_KEY) || 0) > ERROR_RETRY_WINDOW_MS
    ) {
      sessionStorage.setItem(ERROR_RETRY_KEY, String(Date.now()));
      return router.createUrlTree(['/workspace']);
    }

    return true; // legit navigation or same-page reload
  }

  router.navigate([PAGE_NOT_FOUND_PATH]);
  return false;
};